import { useState } from "react";
import axios from "axios";
import { getData } from "@/lib/utils";
import api from "@/store/api";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
// import useLogin from "./use-login";

const useLobby = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // const { refreshToken } = useLogin();
  const getTotaltenderQuotations = async () => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(`/web/tenderQuotations/getTotal`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(err.response?.data?.message || t("alerts.error.fetchOffer"));
      
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const getTotaltenderOpenedQuotations = async () => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(`/web/tenderQuotations/getTotal/Opened`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(
          err.response?.data?.message ||
            t("statistics.totalTenderOpenedQuotations")
        );
       
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };

  const getTotaltenderClosed = async () => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(`/web/tenderQuotations/getTotal/Closed`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(
          err.response?.data?.message || t("statistics.totalTenderClosed")
        );
        
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const gettenderBStatus = async () => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(`/web/tenders/getTotal/ByStatus`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        // if (err.response?.data?.details === "Unauthorized") {
          // const res = await refreshToken();
          // console.log(res);
          // if (res) {
          //   // window.location.reload();
          // }
        // }
        if (err.response?.status === 404) {
          return null;
        }
        setError(err.response?.data?.message || t("statistics.chartTitle"));
        
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };

  const gettenderStatus = async () => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(
        `/web/tenderQuotations/getTotal/ByStatus`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(err.response?.data?.message || t("statistics.chartTitle"));
        
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const getListtenderQuotations = async () => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      // const queryParams = new URLSearchParams(params).toString();

      const response = await api.get(
        `/web/tenderQuotations/getAll?pageSize=10&pageNumber=1&withPaging=false`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(
          err.response?.data?.message || t("statistics.listTenderQuotations")
        );
        
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const getListtenderQuotationsByOfferId = async (OfferId: string) => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(`/web/tenderQuotations/getAll/Offert`, {
        params: { OfferId },
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(
          err.response?.data?.message ||
            t("statistics.listTenderQuotationsByOfferId")
        );
        
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const getListtenderQuotationsByOfferIdMy = async (OfferId: string) => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(`/web/tenderQuotations/getAll/MyOffert`, {
        params: { OfferId },
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(
          err.response?.data?.message ||
            t("statistics.listTenderQuotationsByOfferIdMy")
        );
        
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const getTotaltenderOpened = async () => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(`/web/tenderQuotations/getAll/Opened`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(
          err.response?.data?.message || t("statistics.totalTenderOpened")
        );
       
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const getTotaltenderAllClosed = async () => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(`/web/tenderQuotations/getAll/Closed`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(
          err.response?.data?.message || t("statistics.totalTenderAllClosed")
        );
        
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const getTotalMytenderQuatations = async () => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(
        `/web/tenderQuotations/getAll/All/Opened`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          return null;
        }
        setError(
          err.response?.data?.message || t("statistics.totalMyTenderQuotations")
        );
        
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  return {
    getListtenderQuotationsByOfferIdMy,
    gettenderBStatus,
    getListtenderQuotationsByOfferId,
    getTotalMytenderQuatations,
    getTotaltenderAllClosed,
    getTotaltenderOpened,
    getTotaltenderQuotations,
    getTotaltenderOpenedQuotations,
    getTotaltenderClosed,
    gettenderStatus,
    getListtenderQuotations,
    isLoading,
    error,
  };
};

export default useLobby;
